import 'reactjs-popup/dist/index.css';

import React from 'react';
import Popup from 'reactjs-popup';

export default class Tooltip extends React.Component {
  render() {
    const { children, content } = this.props;

    return (
      <Popup
        trigger={children}
        contentStyle={{
          width: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
        }}
        arrowStyle={{display: 'none'}}
        position="top center"
        on="hover"
      >
        {content}
      </Popup>
    );
  }
}
